import { StyleSheet, Text, View, ViewStyle } from "react-native";
import { Colors, Spacing, Typography } from "../../styles";
import { Data } from "../../types";
import { FontAwesome5 } from "@expo/vector-icons";
import { timestampToRelativeTime } from "../../utils";
import { entityIcon } from "../../utils/data";

interface Props {
  entity: Data.Entity | undefined;
  text: string;
  date: number;
  style?: ViewStyle;
}
const Observation = ({ entity, text, date, style }: Props) => {
  return (
    <View style={[styles.container, style]}>
      <View style={styles.main}>
        {entity && (
          <View style={[styles.row, styles.entity]}>
            <FontAwesome5
              name={entityIcon(entity)}
              size={14}
              color={Colors.white}
              style={styles.icon}
            />
            <Text style={[Typography.paragraph, styles.entityText]}>
              {entity}
            </Text>
          </View>
        )}
        <Text style={Typography.paragraph}>{text}</Text>
      </View>
      <Text style={[Typography.paragraph, { opacity: 0.5 }]}>
        {timestampToRelativeTime(date)}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderRadius: Spacing.cardRadius,
    borderWidth: 1,
    borderColor: Colors.plum400,
    padding: 10,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  main: {
    flex: 1,
    marginRight: 8,
  },
  entity: { marginBottom: 5 },
  entityText: {
    textTransform: "capitalize",
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
  },
  icon: {
    marginRight: 5,
  },
});

export default Observation;
